import React from 'react';
import styled from 'styled-components';
import { Form as oldForm } from '@ant-design/compatible';

const OldItem = styled(oldForm.Item)`
  margin-bottom: 0 !important;
`;

const FormItem = props => <OldItem {...props} />;

FormItem.propTypes = {};

export default FormItem;
